/**
 * @generated SignedSource<<5cef73fc380c283bee75cc5da2c49be9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type incomeCurvesPage_PaybackQuery$variables = {
  year: number;
};
export type incomeCurvesPage_PaybackQuery$data = {
  readonly incomeCacPayback: ReadonlyArray<{
    readonly label: string;
    readonly points: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly size: number;
  }>;
};
export type incomeCurvesPage_PaybackQuery = {
  response: incomeCurvesPage_PaybackQuery$data;
  variables: incomeCurvesPage_PaybackQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "year"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "year",
    "variableName": "year"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "incomeCurvesPage_PaybackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CohortRateCurve",
        "kind": "LinkedField",
        "name": "incomeCacPayback",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "points",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "incomeCurvesPage_PaybackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CohortRateCurve",
        "kind": "LinkedField",
        "name": "incomeCacPayback",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "points",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4e5e329f4fe020511bdb0ef42f0c4eaf",
    "id": null,
    "metadata": {},
    "name": "incomeCurvesPage_PaybackQuery",
    "operationKind": "query",
    "text": "query incomeCurvesPage_PaybackQuery(\n  $year: Int!\n) {\n  incomeCacPayback(year: $year) {\n    label\n    size\n    points {\n      month\n      value\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "83bbece0e0cd00c029e75bebfe4c36d1";

export default node;
